<template>
	<div
		class="flex flex-col justify-center items-center min-h-screen"
		:style="getBackgroundCSS"
	>
		<Head>
			<title>{{ fullTitle }}</title>
		</Head>
		<Analytics :title="fullTitle" />
		<clear-session-storage />
		<div class="max-w-4xl bg-white shadow-lg rounded-2xl overflow-hidden my-4">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue";
export default {
	components: {
		Head,
	},
	props: {
		title: {
			type: String,
			required: false,
		},
	},
	computed: {
		getBackgroundCSS: () =>
			"background:url(" +
			window.baseUrl +
			"/images/rape-field-bg.jpg); background-size: cover",
		fullTitle() {
			return (this.title ? __(this.title) + " | " : "") + "cropspot";
		},
	},
};
</script>
